import { render, staticRenderFns } from "./UserCertificatesSidebar.vue?vue&type=template&id=ff8571c4"
import script from "./UserCertificatesSidebar.vue?vue&type=script&lang=js"
export * from "./UserCertificatesSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports